"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
const chapters = [{
  id: "ch1",
  number: "01",
  title: "Kronologi Peristiwa",
  subDescription: "Penjelasan mendalam mengenai urutan kejadian yang menjadi dasar klarifikasi.",
  content: "Berdasarkan penelusuran tim redaksi dan verifikasi data di lapangan, peristiwa yang beredar di media sosial pada tanggal tersebut memerlukan pelurusan konteks. Informasi awal yang tersebar belum mencakup keseluruhan fakta yang terjadi di lokasi kejadian. Kami telah menghimpun keterangan dari saksi mata kunci dan meninjau rekaman dokumentasi resmi untuk memastikan bahwa narasi yang disampaikan ke publik berdiri di atas landasan kebenaran yang utuh dan tidak memihak."
}, {
  id: "ch2",
  number: "02",
  title: "Hasil Investigasi Internal",
  subDescription: "Langkah-langkah verifikasi dan validasi data yang telah dilakukan tim.",
  content: "Proses audit informasi dilakukan dengan melibatkan departemen kepatuhan dan tim investigasi khusus. Kami menemukan adanya diskrepansi antara laporan awal dengan realita operasional yang ada. Penggunaan data sekunder yang tidak terverifikasi oleh pihak ketiga menjadi pemicu utama kesalahpahaman ini. Sebagai bentuk tanggung jawab profesional, kami menyajikan data pembanding yang valid guna memberikan perspektif yang lebih jernih bagi seluruh pembaca dan pemangku kepentingan."
}, {
  id: "ch3",
  number: "03",
  title: "Komitmen Transparansi",
  subDescription: "Upaya berkelanjutan dalam menjaga integritas informasi publik.",
  content: "Integritas adalah pilar utama dalam setiap informasi yang kami sajikan. Kami berkomitmen untuk selalu melakukan mekanisme check and re-check sebelum sebuah informasi dirilis ke ruang publik. Klarifikasi ini bukan sekadar bantahan, melainkan upaya edukasi agar masyarakat lebih kritis dalam menyerap informasi. Kami membuka ruang dialog bagi pihak-pihak yang ingin mendalami kasus ini lebih lanjut demi terciptanya ekosistem informasi yang sehat, akurat, and dapat dipertanggungjawabkan."
}];
export default function BookContent() {
  return <section data-section-id="185128" id="isi-klarifikasi" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-12 lg:grid-cols-12 gap-8 lg:gap-12">
          
          <div className="md:col-span-12 lg:col-span-8 xl:col-span-9">
            
            <div className="mt-8">
              <h1 className="font-sans text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground">
                Detail Klarifikasi Publik
              </h1>
              <span className="font-sans text-lg md:text-lg lg:text-xl text-muted-foreground mt-4 block">
                Transparansi dan Akurasi Informasi
              </span>
            </div>

            <Separator className="my-8 bg-border" />

            <div className="space-y-12 md:space-y-8 lg:space-y-12 max-w-full md:max-w-[700px] lg:max-w-[800px]">
              {chapters.map((chapter, i) => <div key={chapter.id} data-index={i} className="py-4">
                  <span className="font-sans text-sm font-bold tracking-wider text-primary">
                    {chapter.number}
                  </span>
                  <h2 className="font-sans text-2xl md:text-3xl lg:text-4xl font-bold mt-2 text-foreground">
                    {chapter.title}
                  </h2>
                  {chapter.subDescription && <p className="font-sans text-muted-foreground mt-2 text-base md:text-lg lg:text-xl">
                      {chapter.subDescription}
                    </p>}
                  <p className="font-sans text-base md:text-lg lg:text-xl leading-relaxed mt-6 text-foreground">
                    {chapter.content}
                  </p>
                </div>)}
            </div>

          </div>
          
          <div className="hidden lg:block lg:col-span-4 xl:col-span-3">
            
          </div>
        </div>
      </div>
    </section>;
}